import React from 'react';
import { motion } from 'framer-motion';

const Marquee = ({ items, speed = 50 }) => {
  return (
    <div className="marquee-container">
      <motion.div
        className="marquee-content"
        animate={{
          x: [0, -1920],
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: speed,
            ease: "linear",
          },
        }}
      >
        {[...items, ...items, ...items].map((item, idx) => (
          <span key={idx} className="marquee-item">
            {item}
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default Marquee;
